import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Subject, Subscription, Observable } from 'rxjs';

import { ModalContainerComponent } from '../../../../../../components/modals/modal-container.component';
import { RuleAuditHistoryAction } from '../../../../../../../../shared/constants/rule-audit-history';
import { CustomValidators } from '../../../../../../services/helpers/form-custom-validators';
import { ErrorMessageService } from '../../../../../../services/error-message.service';
import { $formFields } from '../../../../manual-evaluations/manual-evaluation/manual-audit-issues/constants/form-fields';

@Component({
  styleUrls: ['./issue-action-modal.component.scss'],
  templateUrl: './issue-action-modal.component.html',
  standalone: false,
})
export class IssueActionModalComponent implements OnInit, OnDestroy, AfterViewInit {
  private subscriptions: Subscription;

  @ViewChild(ModalContainerComponent, { static: true })
  public container: ModalContainerComponent;

  @ViewChild('reasonTextarea')
  public reasonTextarea: ElementRef<HTMLTextAreaElement>;

  @Input() public reasonIsRequired: boolean;
  public _action: RuleAuditHistoryAction;
  public confirmed: boolean;
  public form: UntypedFormGroup;
  public formValidationRequest: Subject<void>;
  public formValidationRequest$: Observable<void>;

  @Input()
  public set action(action: RuleAuditHistoryAction) {
    this._action = action;
  }

  public constructor(
    private formBuilder: UntypedFormBuilder,
    private element: ElementRef<Element>,
    private errorMessageService: ErrorMessageService,
    private changeDetectorRef: ChangeDetectorRef,
  ) {
    this.formValidationRequest = new Subject<void>();
    this.formValidationRequest$ = this.formValidationRequest.asObservable();
    this.subscriptions = new Subscription();
  }

  public close(): void {
    this.container.closeModal();
  }

  public onAction(): void {
    this.formValidationRequest.next();
    if (this.form.valid === false) {
      this.errorMessageService.setFocusOnFirstError(this.element.nativeElement);
      return;
    }
    this.confirmed = true;
    this.close();
  }

  public ngOnInit(): void {
    this.form = this.formBuilder.group({
      [$formFields.reason]: this.reasonIsRequired
        ? this.formBuilder.control('', [CustomValidators.validateIsEmpty])
        : this.formBuilder.control(''),
    });
    this.subscriptions.add(
      this.formValidationRequest$.subscribe(() => {
        this.changeDetectorRef.detectChanges();
      }),
    );
    this.changeDetectorRef.detectChanges();
  }

  public ngAfterViewInit(): void {
    this.reasonTextarea.nativeElement.focus();
  }

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
